import React from "react"

import { ADMIN_ROUTES, FEATURES_TYPE, NEWS_MANAGEMENT_ROUTES } from "@constants"
import { RedirectWithSearch } from "Pages/OneWay/Routes"


// News Management lives inside Admin since CU-869fmherf (`AdminRoutes`). What is left here is the old
// address, routed but never in the menu (no `id`), redirecting with its `?…`. Without `news_management`
// there is no alias either and the URL ends in the 404, as before.
export const NewsManagementRoutes = userData => {
	if (!userData?.featuresV2?.[FEATURES_TYPE.NEWS_MANAGEMENT]) return []

	return [{
		path: NEWS_MANAGEMENT_ROUTES.PATH,
		element: <RedirectWithSearch to={ADMIN_ROUTES.NEWS_MANAGEMENT_PATH}/>,
	}]
}
